/**
 * Mapping API -> UI pour la liste des profils.
 * Responsabilité: transformer `UtilisateurListItem` (contrat backend) en `ProfileListRow` (contrat UI).
 */
import type { ProfileListRow } from 'lauria/pages/profiles/profilesListRow.types'
import type {
  UtilisateurListItem,
  UtilisateurPermission,
} from 'lauria/types/utilisateur'

function extractTagNamesByPermission(
  utilisateur: UtilisateurListItem,
  permission: UtilisateurPermission
): string[] {
  return (utilisateur.tags ?? [])
    .filter((tag) => tag.permission === permission)
    .map((tag) => tag.nomTag)
    .filter((nomTag) => nomTag.trim() !== '')
    .sort((a, b) => a.localeCompare(b, 'fr', { sensitivity: 'base' }))
}

export function utilisateurListItemToProfileListRow(
  utilisateur: UtilisateurListItem
): ProfileListRow {
  return {
    idProfile: utilisateur.idUtilisateur.toString(),
    email: utilisateur.email,
    nomUtilisateur: utilisateur.nomUtilisateur,
    compteService: utilisateur.compteService,
    nom: utilisateur.nom,
    prenom: utilisateur.prenom,
    tagsUtilisateur: extractTagNamesByPermission(utilisateur, 'utilisateur'),
    tagsAdministrateur: extractTagNamesByPermission(
      utilisateur,
      'administrateur'
    ),
  }
}
